import { Schedule } from "shared";

export const combineDateAndTime = ({
  date,
  time,
}: {
  date: string;
  time: string;
}) => {
  const dateComponents = date.split("T")[0].split("-");
  const timeComponents = time.split("T")[1].split(":");

  const year = parseInt(dateComponents[0]);
  const month = parseInt(dateComponents[1]) - 1;
  const day = parseInt(dateComponents[2]);
  const hour = parseInt(timeComponents[0]);
  const minute = parseInt(timeComponents[1]);
  const second = parseInt(timeComponents[2]);

  const combinedDate = new Date(year, month, day, hour, minute, second);
  // console.log(
  //   "🚀 ~ file: combineTimeDate.ts:8 ~ date:",
  //   date,
  //   time,
  //   combinedDate.toISOString()
  // );
  return combinedDate.toISOString();
};

export const combineDateAndTimeV2 = ({
  date,
  time,
}: {
  date: string;
  time: string;
}) => {
  try {
    const dateA = new Date(date);

    dateA.setHours(0, 0, 0, 0);
    dateA.setHours(new Date(time).getHours());
    dateA.setMinutes(new Date(time).getMinutes());
    dateA.setSeconds(new Date(time).getSeconds());

    const combinedDateTime = dateA.toISOString();

    return combinedDateTime;
  } catch (e) {
    return "";
  }
};

export const startEndCombineDate = async (schedule: Schedule[]) => {
  const combinedDate: Array<any> = [];
  schedule?.map((sec) => {
    if (sec.startDate && sec.startTime && sec.endDate && sec.endTime) {
      combinedDate.push({
        start_time: combineDateAndTimeV2({
          date: sec.startDate,
          time: sec.startTime,
        }),
        end_time: combineDateAndTimeV2({
          date: sec.endDate,
          time: sec.endTime,
        }),
      });
    }
  });

  return combinedDate;
};
